import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./ListProduct.css";
import crossIcon from "../Assets/delete.png";
import editIcon from "../Assets/edit.png";
import { backend_url, currency } from "../../App";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProductPopup from "../ProductDetailsPopup/ProductPopup";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const ListProduct = () => {
  const [allProducts, setAllProducts] = useState([]);
  const [paginationInfo, setPaginationInfo] = useState({
    totalPages: 1,
    currentPage: 1,
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const productsPerPage = 10;
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleDelete = (_id) => {
    setSelectedVideoId(_id);
    setShowConfirm(true);
  };

  useEffect(() => {
    const total = Math.ceil(filteredProducts.length / productsPerPage);
    setPaginationInfo((prev) => ({
      ...prev,
      totalPages: total,
    }));
  }, [filteredProducts]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch(`${backend_url}/allproducts`);
        const data = await res.json();
        setAllProducts(data); // Store full list
        setFilteredProducts(data); // Initially same
      } catch (err) {
        toast.error("Failed to load products");
      }
    };

    fetchProducts();
  }, []);

 const handleSearch = (e) => {
  const value = e.target.value.toLowerCase();
  setSearchTerm(value);
  setPaginationInfo((prev) => ({ ...prev, currentPage: 1 }));

  const filtered = allProducts.filter(
    (product) =>
      product.name.toLowerCase().includes(value) ||
      product.unique_id.toLowerCase().includes(value)
  );

  setFilteredProducts(filtered);
};

  const removeProduct = async (id) => {
    try {
      const response = await fetch(`${backend_url}/removeproduct`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ id }),
      });

      if (response.ok) {
        // If we're on a page that might now be empty after deletion, go back one page
        if (allProducts.length === 1 && paginationInfo.currentPage > 1) {
          setPaginationInfo((prev) => ({
            ...prev,
            currentPage: prev.currentPage - 1,
          }));
        } else {
          // Otherwise, refetch current page
          const url = `${backend_url}/allpaginationproducts?page=${paginationInfo.currentPage}&limit=${productsPerPage}`;
          const data = await fetch(url).then((res) => res.json());
          setAllProducts(data.products);
          setPaginationInfo({
            totalPages: data.totalPages,
            currentPage: data.currentPage,
          });
        }
        setShowConfirm(false);
        toast.success("Product removed successfully");
      } else {
        toast.error("Failed to remove product");
      }
    } catch (error) {
      toast.error("An error occurred while removing the product");
      console.error(error);
    }
  };

  const handlePageChange = (newPage) => {
    setPaginationInfo((prev) => ({
      ...prev,
      currentPage: newPage,
    }));
  };

  const startIndex = (paginationInfo.currentPage - 1) * productsPerPage;
  const endIndex = startIndex + productsPerPage;
  const paginatedProducts = filteredProducts.slice(startIndex, endIndex);

  const totalPages = Math.ceil(filteredProducts.length / productsPerPage);

  return (
    <>
      <div className="product-list-container">
        {/* Header */}
        <div className="product-list-header">
          <h1 className="product-list-title">All Products</h1>
          <div className="product-list-actions">
              <select
              className="product-list-stock-btn"
              onChange={(e) => {
                const value = e.target.value;

                let filtered = allProducts;
                if (value) {
                  filtered = allProducts.filter((p) => p.status === value);
                }

                setFilteredProducts(filtered);
                setPaginationInfo((prev) => ({ ...prev, currentPage: 1 }));
              }}
            >
              <option value="">All Products</option>
              <option value="In-Stock">In-Stock</option>
              <option value="Low Stock">Low Stock</option>
              <option value="Out of Stock">Out of Stock</option>
            </select>
            <input
              type="text"
              placeholder="Search Products..."
              value={searchTerm}
              onChange={handleSearch}
              className="product-list-search"
            />
         
            <Link to="/addproduct">
              <button className="product-list-add-btn">+ Add Product</button>
            </Link>
          </div>
        </div>

        {/* Loading Indicator */}
        {isLoading && (
          <div className="loading-overlay">
            <div className="loading-spinner"></div>
          </div>
        )}

        {/* Table Wrapper */}
        <div className="product-table-wrapper">
          <table className="product-table">
            <thead className="product-table-thead">
              <tr>
                <th>Image</th>
                <th>Product ID</th>
                <th>Title</th>

                <th>Original Price</th>
                <th>Discount (%)</th>
                <th>Offer Price</th>
                <th>Category</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedProducts.length > 0 ? (
                paginatedProducts.map((product) => (
                  <tr key={product._id}>
                    <td>
                      <LazyLoadImage
                        src={product.images[0]}
                        alt={product.name}
                        effect="blur"
                        className="product-table-image"
                      />
                    </td>
                    <td className="product-table-name">{product.unique_id}</td>
                    <td className="product-table-name">{product.name}</td>

                    <td className="product-table-price">
                      {currency}
                      {product.old_price}
                    </td>
                    <td className="product-table-discount">
                      {product.new_price}%
                    </td>
                    <td className="product-table-offer-price">
                      {currency}
                      {(
                        product.old_price -
                        (product.old_price * product.new_price) / 100
                      ).toFixed(2)}
                    </td>
                    <td className="product-table-category">
                      {product.category}
                    </td>
                    <td>
                      <div className="action-buttons">
                        <button
                          className="view-details-btn"
                          onClick={() => setSelectedProduct(product)}
                        >
                          View
                        </button>
                        <Link to={`/editproduct/${product._id}`}>
                          <img
                            src={editIcon}
                            alt="Edit"
                            className="action-icon"
                            title="Edit Product"
                          />
                        </Link>
                        <button
                          onClick={() => handleDelete(product.id)}
                          className="delete-btn"
                        >
                          <img
                            src={crossIcon}
                            alt="Delete"
                            className="action-icon"
                            title="Delete Product"
                          />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="7"
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    {isLoading ? "Loading..." : "No products found"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        {paginationInfo.totalPages > 1 && (
          <div className="product-list-pagination">
            {/* Previous Button */}
            <button
              onClick={() => handlePageChange(paginationInfo.currentPage - 1)}
              disabled={paginationInfo.currentPage === 1}
              className="pagination-btn"
            >
              &laquo;
            </button>

            {/* Page Numbers */}
            {Array.from({ length: paginationInfo.totalPages }, (_, index) => {
              const pageNumber = index + 1;
              // Show first page, last page, and pages around current page
              if (
                pageNumber === 1 ||
                pageNumber === paginationInfo.totalPages ||
                (pageNumber >= paginationInfo.currentPage - 2 &&
                  pageNumber <= paginationInfo.currentPage + 2)
              ) {
                return (
                  <button
                    key={index}
                    onClick={() => handlePageChange(pageNumber)}
                    className={`pagination-btn ${
                      paginationInfo.currentPage === pageNumber ? "active" : ""
                    }`}
                  >
                    {pageNumber}
                  </button>
                );
              }
              return null;
            })}

            {/* Next Button */}
            <button
              onClick={() => handlePageChange(paginationInfo.currentPage + 1)}
              disabled={
                paginationInfo.currentPage === paginationInfo.totalPages
              }
              className="pagination-btn"
            >
              &raquo;
            </button>
          </div>
        )}
      </div>

      {/* Product Details Popup */}
      {selectedProduct && (
        <ProductPopup
          product={selectedProduct}
          onClose={() => setSelectedProduct(null)}
        />
      )}

      {/* Confirmation Popup */}
      {showConfirm && (
        <div className="confirm-poplay">
          <div className="confirm-content">
            <p>Are you sure you want to delete this product?</p>
            <div className="popup-actions">
              <button
                onClick={() => removeProduct(selectedVideoId)}
                className="confirm-btn"
              >
                Confirm
              </button>
              <button
                onClick={() => setShowConfirm(false)}
                className="cancel-btn"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </>
  );
};

export default ListProduct;
    